import styled from "styled-components"

interface ScaleProps {
  direction: string
}

const Scale = styled.span<ScaleProps>`
  display: inline-block;
  ${({direction}) => direction === "right" && "margin-right: 12px;"}
  ${({direction}) => direction === "left" && "margin-left: 12px;"}
  cursor: pointer;
`

export default Scale
